import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function WarehouseStock() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [binList, setBinList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        warehouse: "",
        warehouse_bin: "",
        item: "",
        quantity: "",
        reserved_quantity: "",
        available_quantity: "",
        unit: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });
    useEffect(() => {
        getWarehouse();
        getWarehouseBin();
        getItem();
        getWarehouseStock();
    }, []);
    const getWarehouse = () => {
        axios
            .get(baseUrl + "warehouse/")
            .then((res) => {
                setWarehouseList(res.data);
            });
    };
    const getWarehouseBin = () => {
        axios
            .get(baseUrl + "warehouse-bin/")
            .then((res) => {
                setBinList(res.data);
            });
    };
    const getItem = () => {
        axios
            .get(baseUrl + "inventory-item/")
            .then((res) => {
                setItemList(res.data);
            });
    };
    const getWarehouseStock = () => {
        setLoading(true);
        axios
            .get(baseUrl + "warehouse-stock/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load warehouse stock.",
                });
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        let updatedForm = {
            ...formData, [name]: value
        };
        if (name === "quantity" || name === "reserved_quantity") {
            const qty = Number(name === "quantity" ? value : updatedForm.quantity || 0);
            const reserved = Number(name === "reserved_quantity" ? value : updatedForm.reserved_quantity || 0);
            updatedForm.available_quantity = (qty - reserved).toFixed(2);
        }
        setFormData(updatedForm);
    };
    const clearForm = () => {
        setFormData({
            warehouse: "",
            warehouse_bin: "",
            item: "",
            quantity: "",
            reserved_quantity: "",
            available_quantity: "",
            unit: "",
            status: 1,
            addedby: userName,
            ip_add: ipAddress,
        });
    };
    const saveWarehouseStock = () => {
        const data = new FormData();
        data.append("warehouse", formData.warehouse);
        data.append("bin", formData.warehouse_bin);
        data.append("item", formData.item);
        data.append("quantity", formData.quantity);
        data.append("reserved_quantity", formData.reserved_quantity);
        data.append("available_quantity", formData.available_quantity);
        data.append("unit", formData.unit);
        data.append("status", formData.status);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        const request = editId === null ? axios.post(baseUrl + "warehouse-stock/", data) : axios.put(baseUrl + `update-warehouse-stock/${editId}/`, data);
        request
            .then(() => {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: editId === null ? "Warehouse Stock saved successfully." : "Warehouse Stock updated successfully.",
                });
                clearForm();
                getWarehouseStock();
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to save warehouse stock.",
                });
            });
    };
    const editWarehouseStock = async (row) => {
        setEditId(row.id);
        setFormData({
            warehouse: row.warehouse.id,
            warehouse_bin: row.bin.id,
            item: row.item.id,
            quantity: row.quantity,
            reserved_quantity: row.reserved_quantity,
            available_quantity: row.available_quantity,
            unit: row.unit,
            status: row.status,
        });
        await axios.get(baseUrl + `update-warehouse-stock/${row.id}/`);
    };
    const deleteWarehouseStock = (id) => {
        Swal.fire({
            title: "Delete Warehouse Stock?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(baseUrl + `update-warehouse-stock/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success", title: "Deleted", text: "Warehouse Stock deleted successfully.",
                        });
                        getWarehouseStock();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error", title: "Error", text: "Unable to delete warehouse stock.",
                        });
                    });
            }
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "warehouse_name",
        headerName: "Warehouse",
        flex: 1,
        renderCell: (params) => (params.row.warehouse?.warehouse_name)
    }, {
        field: "bin_name", headerName: "Bin", width: 180, renderCell: (params) => (params.row.bin?.bin_name)
    }, {
        field: "item_name", headerName: "Item", flex: 1, renderCell: (params) => (params.row.item?.item_name)
    }, {
        field: "quantity", headerName: "Quantity", width: 120,
    }, {
        field: "reserved_quantity", headerName: "Reserved", width: 120,
    }, {
        field: "available_quantity", headerName: "Available", width: 120,
    }, {
        field: "unit", headerName: "Unit", width: 100,
    }, {
        field: "status",
        headerName: "Status",
        width: 100,
        renderCell: (params) => params.value == 1 ? "Active" : "Inactive",
    }, {

        field: "action", headerName: "Action", width: 180, sortable: false, renderCell: (params) => (<>
                <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => editWarehouseStock(params.row)}
                >
                    Edit
                </button>

                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteWarehouseStock(params.row.id)}
                >
                    Delete
                </button>
            </>),
    },];
    return (<div className="container-fluid mt-3">

        <div className="card shadow">

            <div className="card-header bg-primary text-white">

                <h5 className="mb-0">
                    Warehouse Stock
                </h5>

            </div>

            <div className="card-body">

                <div className="row">

                    <div className="col-md-4 mb-3">

                        <label>Warehouse</label>

                        <select
                            className="form-select"
                            name="warehouse"
                            value={formData.warehouse}
                            onChange={handleChange}
                        >

                            <option value="">
                                Select Warehouse
                            </option>

                            {warehouseList.map((item) => (<option
                                key={item.id}
                                value={item.id}
                            >
                                {item.warehouse_name}
                            </option>))}

                        </select>

                    </div>

                    <div className="col-md-4 mb-3">

                        <label>Warehouse Bin</label>

                        <select
                            className="form-select"
                            name="warehouse_bin"
                            value={formData.warehouse_bin}
                            onChange={handleChange}
                        >

                            <option value="">
                                Select Bin
                            </option>

                            {binList.map((item) => (<option
                                key={item.id}
                                value={item.id}
                            >
                                {item.bin_name}
                            </option>))}

                        </select>

                    </div>

                    <div className="col-md-4 mb-3">

                        <label>Item</label>

                        <select
                            className="form-select"
                            name="item"
                            value={formData.item}
                            onChange={handleChange}
                        >

                            <option value="">
                                Select Item
                            </option>

                            {itemList.map((item) => (<option
                                key={item.id}
                                value={item.id}
                            >
                                {item.item_name}
                            </option>))}

                        </select>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label>Quantity</label>

                        <input
                            type="number"
                            className="form-control"
                            name="quantity"
                            value={formData.quantity}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="col-md-3 mb-3">

                        <label>Reserved Quantity</label>

                        <input
                            type="number"
                            className="form-control"
                            name="reserved_quantity"
                            value={formData.reserved_quantity}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="col-md-3 mb-3">
                        <label>Available Quantity</label>

                        <input
                            type="number"
                            className="form-control"
                            name="available_quantity"
                            value={formData.available_quantity}
                            readOnly
                        />
                    </div>

                    <div className="col-md-3 mb-3">
                        <label>Unit</label>

                        <select
                            className="form-control"
                            name="unit"
                            value={formData.unit}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Unit</option>
                            <option value="Bag">Bag</option>
                            <option value="Kg">Kg</option>
                            <option value="Gram">Gram</option>
                            <option value="Ton">Ton</option>
                            <option value="Litre">Litre</option>
                            <option value="ML">ML</option>
                            <option value="Nos">Nos</option>
                            <option value="Box">Box</option>
                            <option value="Packet">Packet</option>
                            <option value="Bundle">Bundle</option>
                        </select>
                    </div>
                    <div className="col-md-3 mb-3">

                        <label>Status</label>

                        <select
                            className="form-select"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>

                    </div>

                    <div className="col-md-12 mt-3">

                        <button
                            className="btn btn-success me-2"
                            onClick={saveWarehouseStock}
                            disabled={loading}
                        >
                            Save
                        </button>

                        <button
                            className="btn btn-secondary"
                            onClick={clearForm}
                        >
                            Clear
                        </button>

                    </div>

                </div>
                <div className="card shadow mt-3">

                    <div className="card-header bg-primary text-white">

                        <h5 className="mb-0">
                            Warehouse Stock List
                        </h5>

                    </div>

                    <div className="card-body">

                        <div
                            style={{
                                height: 600, width: "100%",
                            }}
                        >

                            <ERPDataGrid
                                rows={rows}
                                columns={columns}
                                loading={loading}
                                getRowId={(row) => row.id}
                                pageSizeOptions={[10, 25, 50, 100,]}

                                disableRowSelectionOnClick
                            />

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>);
}
export default WarehouseStock;